<template>
  <div class="mx-2">

    <div v-if="dish.barcodes.length > 0"
         class="row d-none d-md-flex">
      <div class="col-7 col-md-8 col-lg-6 col-xl-5">
        <label> {{ $t("#TR-barcodes") }}:</label>
      </div>
    </div>

    <div v-else class="row">
      <div class="offset-3 col-6 offset-md-4 col-md-4 offset-lg-3 offset-xl-2 text-muted text-center my-3">
        {{ $t("#TR-add-new-barcode") }}
      </div>
    </div>


    <transition-group name="fade2" mode="out-in" tag="div">
      <div v-for="(barcode, idx) in dish.barcodes"
           :key="`barcode-${idx}`"
           class="row mb-1">
        <div class="col-12 col-md-6 col-lg-6 col-xl-4 d-flex mb-3 mb-md-0">

          <b-form-input v-model="dish.barcodes[idx]"></b-form-input>

          <b-button variant="danger"
                    class="ml-1"
                    size="sm"
                    @click="delBarcode(idx)">
            <i class="mdi mdi-close"></i>
          </b-button>
        </div>
      </div>
    </transition-group>

    <div class="row mt-3">
      <div class="offset-xs-1 col-xs-10 offset-sm-3 col-sm-6 offset-md-4 col-md-4 offset-lg-3 offset-xl-2">
        <b-button block
                  variant="success"
                  @click="addBarcode">
          <i class="mdi mdi-plus align-middle"></i> {{ $t("#TR-add") }}
        </b-button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'AddBarcode',

    props: {
      dish: {
        type: Object,
        require: true,
        default: () => {
          return { barcode: [] };
        }
      }
    },

    methods: {

      addBarcode() {
        this.dish.barcodes.push(null);
      },

      delBarcode(idx) {
        this.dish.barcodes.splice(idx, 1);
      }
    }
  };
</script>
